import Container from './reg-template.container';

export default Container;
